import { Observable, of, throwError as observableThrowError } from "rxjs";
import { catchError, map, shareReplay, finalize } from "rxjs/operators";
import { xmlTMSSelectCMRActionsXML } from "../../pb-screen/models/TMSSelectCMRActions.interface";
import { HttpClientService } from "./httpclient";
import { PlanningBlock } from "../../pb-screen/models/planning-block/planning-block.interface";
import { Injectable } from "@angular/core";
import { CapacitySlot } from "../../pb-screen/models/capacity-slot.interface";
import { CapacitySlot as CapacitySlot2 } from "../../../app/shared/models/capacity-slot.interface";
import { environment } from "../../../environments/environment";
import { ExportCmrData } from "../../pb-screen/models/CMR-data-raw.interface";
import { OrderLine } from "../../pb-screen/models/order-line/orderLine.interface";
import { Haulier } from "../../pb-screen/models/haulier.interface";
import { TMSPlanningSetup } from "../models/tms-planning-setup";
import { PlanningConflict } from "../../pb-screen/models/planning-conflict.interface";
import { Driver } from "../../static/models/driver.interface";
import * as moment from "moment";
import { Container } from "../../pb-screen/models/planning-block/container.interface";
import { ServiceControllerStatusEnum, WindowsService } from "../models/windows-service";
import { IdNameAsStringObject } from "../../pb-screen/models/quick-view/id-name-as-string-object.interface";
import { TransportOrder } from "../../pb-screen/models/transport-order/transport-order.interface";
import { ActionTemplateScreen } from "../action.template.screen.enum";
import { UpdatePlanningBlock } from "../models/planning-block/update-planning-block.interface";
import { PoolCarrier } from "../../pool/models/pool-carrier.interface";
import { FileAddress } from "../models/file/file-address.interface";
import { UpdateFile } from "../models/file/update-file.interface";
import { RailwayDeparture } from "../models/RailwayDeparture";
import { ContainerPoolRequestInfo } from "../models/container-pool-request/container.pool.request";
import {
  ContainerReuseBusinessResponse,
  ConfirmContainerReuseResponse,
  ContainerReuseInfo,
  ContainerReusePreviewRequest,
  ContainerReusePreviewResponse,
  RequestContainerReuseResponse,
} from "../models/container-reuse/container.reuse.interface";

import { ActionTemplateAddress, ActionTemplateInsertLineViewModel } from "../components/modals/reroute-modal/reroute-modal.interface";
import { TransportOrderWithPlanUnit } from "../models/transport-order/transport-order-with-plan-unit.interface";
import { TransportOrderPlanUnit } from "../models/transport-order/transport-order-plan-unit.interface";
import { File } from "../models/file/file.interface";
import { AddressLocation } from "../models/address-location";
import { ErrorHttpParams } from "./errror.httpparams";
import { TranslateService } from "@ngx-translate/core";
import { UserFeedbackService } from "../../services/user-feedback.service";
import { UpdateContainerStatusModel } from "../models/update-container-status-model.interface";
import {PlanningStatus} from "../../pb-screen/models/status-type.interface";
import {HttpParams} from "@angular/common/http";
import { DevLoggerService } from "./dev-logger.service";

@Injectable()
export class SharedService {
  public myUpdatedObject: xmlTMSSelectCMRActionsXML;
  public ScreenName: string = "";
  private orderLinesInFlight: Map<string, Observable<OrderLine[]>> = new Map();

  constructor(
    private readonly http: HttpClientService,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly translate: TranslateService,
    private readonly devLogger: DevLoggerService,
  ) {
  }

  public updateDepotInDate(planningBlockId: number, depotInDate: string, userId: string) {
    const apiWrapper = {
      depotInDate: {
        Date: depotInDate,
      },
      userId,
    };

    return this.http
      .put(environment.ContainerPlanningApiUri + "planningBlocks/" + planningBlockId + "/depot-in-date", apiWrapper)
      .pipe(map((response: any) => {
        return response.data;
      }));
  }

  public updateContainerNumber(planningBlockId: number, containerNumber: string, userId: string) {
    const apiWrapper = {
      value: containerNumber,
      userId,
    };
    return this.http
      .put(environment.ContainerPlanningApiUri + "planningBlocks/" + planningBlockId + "/container-number", apiWrapper)
      .pipe(map((response: any) => {
        return response.data;
      }));
  }

  public updatePlanningBlockStatus(planningBlock: PlanningBlock, newStatus: string, newLocation: AddressLocation, userId: string):
    Observable<PlanningBlock> {
    let addressId = "";
    let location = "";
    if (newLocation && newLocation.addressId) {
      addressId = newLocation.addressId;
    }
    if (newLocation && newLocation.locationCode) {
      location = newLocation.locationCode;
    }

    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/" + planningBlock.id + "/container-status",
        {
          addresslocation: {
            addressId,
            locationCode: location,
          },
          status: newStatus,
          userId,
        })
      .pipe(
        map((res: any) => {
          return res.data;
        }),
        catchError((err) => {
          return observableThrowError(err);
        }),
      );
  }
  public updateBulkPlanningBlocksStatus(updateModelStatus: UpdateContainerStatusModel[] ): Observable<PlanningBlock[]> {

    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/update-containers-status",
        updateModelStatus
       )
      .pipe(
        map((res: any) => {
          return res.data;
        }),
        catchError((err) => {
          return observableThrowError(err);
        }),
      );
  }

  public getCapacitySlots(planDate): Observable<[CapacitySlot]> {
    const group = "ALL";
    const zone = "";
    const startDate = moment(planDate).hours(0).minutes(0).seconds(0).toISOString();
    const endDate = moment(planDate).hours(23).minutes(59).seconds(59).toISOString();
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning?startDate=" + startDate
        + "&endDate=" + endDate + "&zone=" + zone + "&group=" + group).pipe(
        map((response: any) => response.data),
        catchError((err) => {
          return observableThrowError(err);
        })
      );
  }

  public getCapacitySlotsCpl(planDate, planningGroups): Observable<[CapacitySlot]> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "capacityslots/?planDate=" + planDate + "&planningGroups=" + planningGroups)
      .pipe(
        map((response: any) => response.data),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }


  public getCapacitySlotsLight(planDate) {
    const group = "ALL";
    const zone = "";
    const startDate = moment(planDate).hours(0).minutes(0).seconds(0).toISOString();
    const endDate = moment(planDate).hours(23).minutes(59).seconds(59).toISOString();
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning/light?startDate=" + startDate
        + "&endDate=" + endDate + "&zone=" + zone + "&group=" + group).pipe(
        map((response: any) => response.data),
        catchError((err) => {
          return observableThrowError(err);
        })
      );
  }

  public getCapacitySlotsAll() {
    const group = "ALL";
    const zone = "";
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning/all?zone=" + zone + "&group=" + group).pipe(
        map((response: any) => response.data),
        catchError((err) => {
          return observableThrowError(err);
        })
      );
  }


  public getDrivers(): Observable<Driver[]> {
    const daysAhead = environment.defaultPlanDaysAhead;
    const daysBack = environment.defaultPlanDaysBack;
    return this.http.get(environment.tmsApiEndpointAddress + "planning/drivers?daysAhead=" + daysAhead + "&daysBack=" + daysBack).pipe(
      map((response: any) => response.data as Driver[]),
      catchError((err) => {
        return observableThrowError(err);
      })
    );
  }

  public getPlanningGroups(): Observable<IdNameAsStringObject[]> {
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning/groups").pipe(
        map((response: any) => {
          return response.data as IdNameAsStringObject[];
        }));
  }

  public getCPPlanningGroups(): Observable<IdNameAsStringObject[]> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "planningblocks/get-planning-groups").pipe(
        map((response: any) => {
          return response.data as IdNameAsStringObject[];
        }));
  }

  public getContainerStatuses(): Observable<IdNameAsStringObject[]> {
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning/container-statuses").pipe(
        map((response: any) => {
          return response.data as IdNameAsStringObject[];
        }),
        catchError((err) => {
          return observableThrowError(err);
        }));
  }

  public getTruckDepartments(): Observable<IdNameAsStringObject[]> {
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning/truck-departments").pipe(
        map((response: any) => {
          return response.data as IdNameAsStringObject[];
        }));
  }

  public getPlanningHauliers(): Observable<[Haulier]> {
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning/hauliers").pipe(
        map((response: any) => {
          return response.data;
        }),
        catchError((err) => {
          return observableThrowError(err);
        })
      );
  }

  public getCMRDataFromPlanningBlockById(planningBlockId: number): Observable<ExportCmrData> {
    return this.http
      .get(environment.tmsApiEndpointAddress + "planningBlocks/" + planningBlockId + "/cmr")
      .pipe(map((response: any) => response.data));
  }

  public getCPCMRDataFromPlanningBlockById(planningBlockId: number): Observable<ExportCmrData> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "planningBlocks/" + planningBlockId + "/cmr")
      .pipe(map((response: any) => response.data));
  }

  public getOrderLines(ids: string): Observable<OrderLine[]> {
    if (!ids) {
      this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PB_NOT_SELECTED");
      return;
    }

    if (this.orderLinesInFlight.has(ids)) {
      return this.orderLinesInFlight.get(ids);
    }

    const request$ = this.http
      .get(environment.tmsApiEndpointAddress + "planningBlocks/" + ids + "/orderlines")
      .pipe(
        map((response: any) => response.data),
        shareReplay(1),
        finalize(() => this.orderLinesInFlight.delete(ids))
      );

    this.orderLinesInFlight.set(ids, request$);
    return request$;
  }

  public getTMSPlanningSetup(): Observable<TMSPlanningSetup> {
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning-setup")
      .pipe(
        map((response: any) => {
          return response.data;
        }),
        catchError((err) => {
          return observableThrowError(err);
        })
      );
  }

  public calculatePlanningBlockConflicts(transportOrderIdsCommaSeparated: string): Observable<PlanningConflict[]> {
    this.devLogger.apiRequest('GET', 'transportorders/calculateConflicts', { transportOrderIds: transportOrderIdsCommaSeparated });
    return this.http.get(environment.tmsApiEndpointAddress + "transportorders/calculateConflicts?transportOrderId=" + transportOrderIdsCommaSeparated).pipe(
      map(
        (res: any) => {
          const conflicts = res.data.flatMap(to => to.planningConflicts) as PlanningConflict[];
          this.devLogger.conflict(`calculateConflicts returned ${conflicts.length} conflicts`, conflicts);
          return conflicts;
        }),
      catchError((err) => {
        this.devLogger.api('calculateConflicts FAILED', err, true);
        return observableThrowError(err);
      })
    );
  }

  public calculatePlanningBlockConflictsReturnTo(transportOrderId: string): Observable<TransportOrder[]> {
    return this.http.get(environment.tmsApiEndpointAddress + "transportorders/calculateConflicts?transportOrderId=" + transportOrderId).pipe(
      map(
        (res: any) => {
          return res.data as TransportOrder[];
        }),
      catchError((err) => {
        return observableThrowError(err);
      })
    );
  }

  public hideConflictForTo(conflictEntryNo: string, transportOrderId: string): Observable<TransportOrder | null> {
    return this.http.post(environment.tmsApiEndpointAddress + "transportorders/hideConflict?conflictEntryNo=" + conflictEntryNo + "&transportOrderId=" + transportOrderId, null).pipe(
      map(
        (res: any) => {
          // Ignore null responses from server
          return res.data !== null && res.data !== undefined ? res.data as TransportOrder : null;
        }),
      catchError((err) => {
        return observableThrowError(err);
      })
    );
  }

  public hideConflictForPb(conflictEntryNo: string, pbId: number): Observable<PlanningBlock> {
    return this.http.post(environment.tmsApiEndpointAddress + "planningblocks/hideConflict?conflictEntryNo=" + conflictEntryNo + "&pbId=" + pbId, null).pipe(
      map(
        (res: any) => {
          return res.data as PlanningBlock;
        }),
      catchError((err) => {
        return observableThrowError(err);
      })
    );
  }

  public getAddressLocations(): Observable<AddressLocation[]> {
    return this.http.get(environment.tmsApiEndpointAddress + "planning/address-locations").pipe(
      map((res: any) => res.data),
      catchError((err) => {
        return observableThrowError(err);
      })
    );
  }

  public checkContainerNumber(containerNumber: string) {
    return this.http.get(environment.tmsApiEndpointAddress + "planning/check-container-number?containerNumber=" + containerNumber).pipe(
      map((res: any) => res),
      catchError((err) => observableThrowError(err.error)),
    );
  }

  public updatePlanningBlock(dataLoad: any): Observable<PlanningBlock> {
    return this.http.put(environment.tmsApiEndpointAddress + "planningblocks/update-pb", dataLoad).pipe(
      map((res: any) => res.data),
      catchError((err) => observableThrowError(err.error)),
    );
  }

  public updatePlanningBlocks(multiplePbUpdateParameters: any[]): Observable<PlanningBlock[]> {
    return this.http.put(`${environment.tmsApiEndpointAddress}planningblocks/update-pbs`, multiplePbUpdateParameters).pipe(
      map((responses: any[]) => {
        const result = [];

        for (const response of responses) {
          result.push(response.data);
        }

        return result;
      }),
      catchError((err) => observableThrowError(err.error)),
    );
  }

  public getContainersForPlanningBlock(pbId: number): Observable<Container[]> {
    return this.http.getWithConfig(environment.tmsApiEndpointAddress + "planningblocks/" + pbId + "/containers",
      {
        params: new ErrorHttpParams(true)
      }).pipe(
      map((res: any) => res.data as Container[]),
      catchError((err) => observableThrowError(err.error)),
    );
  }

  public getMonitoringServiceStatus(): Observable<WindowsService> {
    return this.http.get(environment.tmsApiEndpointAddress + "services").pipe(
      map((res: any) => res.data as WindowsService),
      catchError(_ => of({ status: ServiceControllerStatusEnum.Stopped } as WindowsService))
    );
  }

  public getMonitorServiceStatusPlanBoard(): Observable<WindowsService> {
    return this.http.get(environment.tmsApiEndpointAddress + "services/plan-board").pipe(
      map((res: any) => res.data as WindowsService),
      catchError((err) => observableThrowError(err.error)),
    );
  }

  public getUserAzureGroups(userId): Observable<any[]> {
    return this.http.get(environment.tmsApiEndpointAddress + "users/" + userId).pipe(
      map((res: any) => res.data.groups),
      catchError((err) => observableThrowError(err.error)),
    );
  }

  public getTrailersForPbId(pbId): Observable<any[]> {
    return this.http.get(environment.tmsApiEndpointAddress + "planningblocks/" + pbId + "/trailers").pipe(
      map((res: any) => res.data),
      catchError((err) => observableThrowError(err))
    );
  }

  public checkDriverAbsence(planDate, employeeId): Observable<any[]> {
    return this.http.get(environment.tmsApiEndpointAddress + "driveragenda/check-driver-absence?planDate=" + planDate + "&driverId=" + employeeId)
      .pipe(map((res: any) => res.data),
        catchError((err) => observableThrowError(err))
      );
  }

  public postPbRemark(pbId: number, txtRemark: string, userId: string) {
    const apiWrapper = {
      remark: {
        value: txtRemark,
      },
      userId,
    };

    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/" + pbId + "/pb-remark", apiWrapper)
      .pipe(
        map((response: any) => {
          return response.data;
        }),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public checkContainerNumberCpl(containerNumber: string, userId: string, selectedPlanningBlock?: PlanningBlock) {
    const apiWrapper = {
      value: containerNumber,
      userId,
    };

    return this.http
      .put(environment.ContainerPlanningApiUri + "planningblocks/check-container-number", apiWrapper)
      .pipe(
        map((res: any) => res),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public checkContainerNumbersInFile(fileNumber: string, containerNumber: string) {
    return this.http
      .get(environment.ContainerPlanningApiUri +
        "planningblocks/get-pbs-by-file-no/" +
        encodeURIComponent(fileNumber))
      .pipe(
        map((res: any) => {
          const pbs: PlanningBlock[] = res.data;
          return pbs.every((planningBlock: PlanningBlock) => planningBlock.containerNo !== containerNumber);
        }),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public updateInitials(formBody) {


    return this.http.post(environment.ContainerPlanningApiUri + "planningBlocks/update-initial-datetime", formBody)
      .pipe(
        map((res: any) => {
          return res.data;
        }),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public getValidContainerStatuses(orderNumber: string, currentStatus: string) {
    return this.http
      .get(environment.ContainerPlanningApiUri + "orders/" + orderNumber + "/statuses?currentStatus=" + currentStatus)
      .pipe(map((response: any) => {
          return response.data;
        }),
        catchError((err) => {
          return Observable.throw(err);
        }));
  }

  public getPlanningBlockById(id: number) {
    return this.http
      .get(environment.ContainerPlanningApiUri + "planningBlocks/" + id)
      .pipe(map((response: any) => response.data));
  }


  public getPlanningBlocksByIds(pbIds: number[]): Observable<PlanningBlock[]> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningBlocks/fetch", pbIds)
      .pipe(
        map((res: any) => res.data as PlanningBlock[])
        , catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public getTmsPlanningBlocksByIds(pbIds: number[]): Observable<PlanningBlock[]> {
    return this.http
      .get(environment.tmsApiEndpointAddress + "planningBlocks/ids?planningBlockIds=" + pbIds.join(","))
      .pipe(map((response: any) => response.data));
  }

  public getPlanningBlockByReuseNo(reuseNo: string) {
    return this.http
      .get(environment.ContainerPlanningApiUri + "planningBlocks/reuseNo/" + encodeURIComponent(reuseNo))
      .pipe(map((response: any) => response.data));
  }

  public containerInOutPool(pbIds: number[], capacityDiaryId: number,
                            containerStatus: string, location: AddressLocation,
                            userId: string, depotInRef1: string, depotOutRef1: string): Observable<PlanningBlock[]> {
    return this.http.post(environment.ContainerPlanningApiUri + "pool/container-in-out-pool", {
      pbIds,
      capacityDiaryId,
      containerStatus,
      tmsAddress: location.addressId,
      location: location.locationCode,
      userId,
      depotInRef1,
      depotOutRef1,
    }).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError((err) => {
        return Observable.throw(err);
      }));
  }

  public prePlanAction(capacity: CapacitySlot2, planUnit: TransportOrderPlanUnit, planDate: string, userId: string, driver: Driver = null): Observable<TransportOrderWithPlanUnit> {
    const newToData = {
      planDate,
      capacitySlot: capacity,
      planUnit,
      truckNo: capacity?.truck.id.toString(),
      haulierNo: capacity?.haulierNo,
      driverNo: capacity?.driver.id,
      userId,
      driver
    };
    return this.http
      .post(environment.ContainerPlanningApiUri + "transportorders", newToData)
      .pipe(
        map((res: any) => res.data as TransportOrderWithPlanUnit),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public group(planUnit: TransportOrderPlanUnit, userId: string): Observable<TransportOrderPlanUnit> {
    const apiWrapper = {

      transportOrderPlanUnit: planUnit,
      userId,
    };
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/group", apiWrapper)
      .pipe(
        map((res: any) => res.data as TransportOrderPlanUnit),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public send(planUnit: TransportOrderPlanUnit, userId: string): Observable<TransportOrderPlanUnit> {
    const apiWrapper = {

      transportOrderPlanUnit: planUnit,
      userId,
    };
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/plan", apiWrapper)
      .pipe(
        map((res: any) => res.data as TransportOrderPlanUnit),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public undoSend(planUnit: TransportOrderPlanUnit, userId: string): Observable<TransportOrderPlanUnit> {
    const apiWrapper = {

      transportOrderPlanUnit: planUnit,
      userId,
    };
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningBlocks/undo-plan", apiWrapper)
      .pipe(
        map((res: any) => res.data as TransportOrderPlanUnit),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public getActionTemplates(actionTemplateScreen: ActionTemplateScreen): Observable<string[]> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "action-template/" + actionTemplateScreen + "/all")
      .pipe(
        map((response: any) => response.data),
        catchError((error: any) => Observable.throw(error)),
      );
  }

  public getActionTemplateAddresses(actionTemplateCode: string): Observable<ActionTemplateAddress[]> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "action-template/" + actionTemplateCode + "/addresses")
      .pipe(
        map((response: any) => response.data),
        catchError((error: any) => Observable.throw(error)),
      );
  }

  public insertActionTemplateLines(actionTemplateInsertLineViewModel: ActionTemplateInsertLineViewModel) {
    return this.http
      .post(environment.ContainerPlanningApiUri + "action-template/", actionTemplateInsertLineViewModel)
      .pipe(
        map((response: any) => response.data),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public undoPreplan(planUnit: TransportOrderPlanUnit, userId: string): Observable<any> {
    const apiWrapper = {

      transportOrderPlanUnit: planUnit,
      userId,
    };
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningBlocks/undo-preplan", planUnit)
      .pipe(
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public unplan(pbIds: number[], userId: string, cancelSendToHaulier: boolean): Observable<PlanningBlock[]> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningBlocks/unplan", { pbIds, userId, cancelSendToHaulier })
      .pipe
      (
        map((res: any) => res.data as PlanningBlock[]),
        catchError((err) => {
          return Observable.throw(err);
        }),
      );
  }

  public getMultipleContainersReuseInfo(reuseNos: string[]): Observable<ContainerReuseInfo[]> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "container/get-multiple-reuse-info", { reuseNos })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {
          return Observable.throw(error);
        }),
      );
  }

  public getContainerReuseInfo(reuseNo: string): Observable<ContainerReuseInfo> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "container/get-reuse-info/" + encodeURIComponent(reuseNo))
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {
          return Observable.throw(error);
        }),
      );
  }

  public getMultipleContainerReuseRequestInfo(reuseNos: string[]): Observable<ContainerReuseInfo[]> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "container/reuse-request/get-multiple", { reuseNos })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {
          return Observable.throw(error);
        }),
      );
  }

  public getContainerReuseRequestInfo(reuseNo: string): Observable<ContainerReuseInfo> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "container/reuse-request/" + encodeURIComponent(reuseNo))
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {
          return Observable.throw(error);
        }),
      );
  }

  public getContainerPoolRequestInfo(containerPoolRequestNo: string): Observable<ContainerPoolRequestInfo> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "pool/request-info/" + encodeURIComponent(containerPoolRequestNo))
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {
          return Observable.throw(error);
        }),
      );
  }

  public getAddressFiltered(filter: any): Observable<any[]> {
    const params = this.buildFilterParams(filter);
    return this.http
      .get(environment.tmsApiEndpointAddress + "planning/address?" + params ).pipe(
        map((response: any) => response.data));
  }

  private buildFilterParams(filter: any): HttpParams {
    let params = new HttpParams();
    for (const property in filter) {
      if (filter.hasOwnProperty(property) && filter[property] != null) {
        params = params.set(`filter_${property}`, filter[property].toString());
      }
    }
    return params;
  }

  public registerContainerReuse(depotInPlanningBlockIds: number,
                                depotOutPlanningBlockIds: number,
                                userId: string): Observable<PlanningBlock[]> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "container/register", {
        depotInPlanningBlockId: depotInPlanningBlockIds,
        depotOutPlanningBlockId: depotOutPlanningBlockIds,
        userId,
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public approveContainerReuse(reuseNo: string, userId: string): Observable<PlanningBlock[]> {
    return this.http
      .put(environment.ContainerPlanningApiUri + "container/approve", { reuseNo, userId })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public appendReuseSummary(payload: {
    reuseNo: string;
    rows: Array<{
      planningBlockId: number;
      orderId: number;
      orderLineId: number;
      orderAction: string;
      address: string;
      reused: boolean;
      wizardCode: string;
      splitPb: boolean;
    }>;
  }): Observable<number[]> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "container/appendReuseSummary", payload)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public previewContainerReuse(payload: ContainerReusePreviewRequest): Observable<ContainerReusePreviewResponse> {
    return this.http
      .postWithConfig(environment.ContainerPlanningApiUri + "container/previewReuse", payload, {
        params: new ErrorHttpParams(true),
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public requestContainerReuse(payload: ContainerReusePreviewRequest): Observable<RequestContainerReuseResponse> {
    return this.http
      .postWithConfig(environment.ContainerPlanningApiUri + "container/reuse-request", payload, {
        params: new ErrorHttpParams(true),
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  // Request and approve in one Business Central call, so a refused approval leaves
  // nothing On Hold (G4L-26-658).
  public requestAndApproveContainerReuse(payload: ContainerReusePreviewRequest): Observable<ConfirmContainerReuseResponse> {
    return this.http
      .postWithConfig(environment.ContainerPlanningApiUri + "container/reuse-request/request-and-approve", payload, {
        params: new ErrorHttpParams(true),
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public approveContainerReuseRequest(reuseNo: string): Observable<ConfirmContainerReuseResponse> {
    return this.http
      .putWithConfig(environment.ContainerPlanningApiUri + "container/reuse-request/approve", { reuseNo }, {
        params: new ErrorHttpParams(true),
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public rejectContainerReuseRequest(reuseNo: string): Observable<ContainerReuseBusinessResponse> {
    return this.http
      .putWithConfig(environment.ContainerPlanningApiUri + "container/reuse-request/reject", { reuseNo }, {
        params: new ErrorHttpParams(true),
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public rejectContainerReuse(reuseNo: string, userId: string): Observable<PlanningBlock[]> {
    return this.http
      .put(environment.ContainerPlanningApiUri + "container/reject", { reuseNo, userId })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public cancelContainerReuse(reuseNo: string, userId: string): Observable<PlanningBlock[]> {
    return this.http.put(environment.ContainerPlanningApiUri + "container/cancel", { reuseNo, userId })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public registerContainerToPoolRequest(planningBlockIds: number[], userId: string): Observable<PlanningBlock[]> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "pool/register-container-request", { planningBlockIds, userId })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public approveContainerToPoolRequest(poolContainerRequestNumbers: string[], selectedAddressCode: string, userId: string): Observable<PlanningBlock[]> {
    return this.http
      .put(environment.ContainerPlanningApiUri + "pool/approve-container-request", {
        containerPoolRequestNumbers: poolContainerRequestNumbers,
        selectedAddressCode,
        userId
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public rejectContainerToPoolRequest(poolContainerRequestNumbers: string[], userId: string): Observable<PlanningBlock[]> {
    return this.http
      .put(environment.ContainerPlanningApiUri + "pool/reject-container-request", {
        containerPoolRequestNumbers: poolContainerRequestNumbers,
        userId
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public cancelContainerToPoolRequest(poolContainerRequestNumbers: string[], userId: string): Observable<PlanningBlock[]> {
    return this.http
      .put(environment.ContainerPlanningApiUri + "pool/cancel-container-request", {
        containerPoolRequestNumbers: poolContainerRequestNumbers,
        userId
      })
      .pipe(
        map((response: any) => response.data),
        catchError((error) => {

          return Observable.throw(error);
        }),
      );
  }

  public planPbsToTrain(PlanningBlocks: PlanningBlock[], railwayLineNo: string,
                        departureId: number, userId: string): Observable<PlanningBlock[]> {

    const pbIds = PlanningBlocks.map((pb) => pb.id);
    const apiWrapper = {
      departureId,
      pbIds,
      railwayLineNo,
      userId,
    };
    return this.http
      .post(environment.ContainerPlanningApiUri + "railway/plan", apiWrapper)
      .pipe(
        map((response: any) => response.data),
        catchError((error) => Observable.throw(error)),
      );
  }

  public getRailwayDepartures(railwayNo: string, planDate: string, userId: string): Observable<RailwayDeparture[]> {
    const apiWrapper = {
      planDate,
      railwayLineNo: railwayNo,
    };
    return this.http
      .post(environment.ContainerPlanningApiUri + "railway/departures", apiWrapper)
      .pipe(map((response: any) => response.data));
  }

  public getOrderLinesCpl(ids: string): Observable<OrderLine[]> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "orderlines/orderlines-by-pb-ids/" + ids)
      .pipe(map((response: any) => response.data));
  }

  public getOrderLinesByOrderNumber(orderNumber: string): Observable<OrderLine[]> {
    if (!orderNumber) {
      return of([]);
    }

    return this.http
      .get(environment.ContainerPlanningApiUri + "orderlines/orderlines-by-order-number?orderNumber=" + encodeURIComponent(orderNumber))
      .pipe(map((response: any) => response.data as OrderLine[]));
  }

  public setWeight(pbId: number, weight: number, userId: string) {
    const apiWrapper = {
      pbId,
      weight,
      userId,
    };

    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/weigh", apiWrapper)
      .pipe(
        map((response: any) => response.data),
        catchError((err) => {
          return Observable.throw(err.error);
        }),
      );
  }

  public getFile(fileNumber: string): Observable<File> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "files?fileNumber=" + fileNumber)
      .pipe(map((response: any) => response.data));
  }

  public updateFile(fileNumber: string, fileViewModel: UpdateFile): Observable<PlanningBlock[]> {
    return this.http
      .put(environment.ContainerPlanningApiUri + "files?fileNumber=" + fileNumber, fileViewModel)
      .pipe(
        map((response: any) => response.data),
        catchError((err) => {

          return Observable.throw(err);
        }),
      );
  }

  public getFileAddresses(): Observable<FileAddress[]> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "files/addresses")
      .pipe(map((response: any) => response.data));
  }

  public getCarriers(): Observable<PoolCarrier[]> {
    return this.http
      .get(environment.ContainerPlanningApiUri + "files/carriers")
      .pipe(
        map((response: any) => {
          const data = response.data;
          return data;
        }),
        catchError((err) => {
          return Observable.throw(err.error);
        }),
      );
  }

  public updatePlanningBlockCpl(updatePlanningBlock: UpdatePlanningBlock): Observable<PlanningBlock> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/update-planning-block", updatePlanningBlock).pipe(
        map((response: any) => {
          const data = response.data;
          return data;
        }, catchError((err) => {

          return Observable.throw(err);
        }))
      );
  }

  public updateDepotOutRefCpl(planningBlockId: number, value: string, type: number, userId: string): Observable<any> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/" + planningBlockId + "/updateDepotOutRef", {
        value,
        type,
        userId,
      })
      .pipe(
        map((response: any) => response.data),
        catchError((err) => Observable.throw(err.error)),
      );
  }

  public updateDepotInRefCpl(planningBlockId: number, value: string, type: number, userId: string): Observable<any> {
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/" + planningBlockId + "/updateDepotInRef", {
        value,
        type,
        userId,
      })
      .pipe(
        map((response: any) => response.data),
        catchError((err) => Observable.throw(err.error)),
      );
  }

  public getPlanningBlocksByFileNumber(fileNumber: string) {
    return this.http
      .get(environment.ContainerPlanningApiUri + "planningblocks/get-pbs-by-file-no/" + fileNumber)
      .pipe(map((response: any) => response.data));
  }

  public updatePlanningGroup(pbIds: number[], planningGroupCode: string) {
    return this.http
      .post(environment.ContainerPlanningApiUri + "planningblocks/update-planning-groups",
        {
          pbIds,
          planningGroupCode
        })
      .pipe(map((response: any) => response.data), catchError((err) => {

        return Observable.throw(err);
      }));
  }


  // Monitoring Service Status
  public startMonitoringService(): Observable<WindowsService> {
    return null;
  }

  public getActivePlanningConflicts(planningGroups: string): Observable<PlanningConflict[]> {
    return this.http.get(environment.ContainerPlanningApiUri + "planningconflicts/get-active-conflicts?planningGroups" + planningGroups).pipe(
      map((res: any) => res.data),
      catchError((err) => Observable.throw(err))
    );
  }

  public planToExistingTos(toId: string, pbs: PlanningBlock[], userId: string, confirmDateChange: boolean = false , planDate: string ): Observable<TransportOrderWithPlanUnit> {

    return this.http.post(environment.ContainerPlanningApiUri + "transportorders/PlanningBlocks?toId=" + toId +
      "&planDate=" + planDate + "&userName=" + userId + "&confirmDateChange=" + confirmDateChange , pbs).pipe(
        map((response: any) => response.data),
        catchError((err) => Observable.throw(err)));
  }

  public getOpenTos(driverNo: string, truckNo: string, planningDate: string) {
    return this.http.get(environment.ContainerPlanningApiUri + "transportorders/open?truckNo=" + truckNo + "&driverNo=" + driverNo + "&planningDate=" + planningDate).pipe(
      map((response: any) =>
         response.data

    ),
      catchError((err) => Observable.throw(err)));
  }


}
